import React, { useState, useEffect } from 'react';

const PeriodSelector = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const [selectedQuarter, setSelectedQuarter] = useState(localStorage.getItem('quarter') || 'Q4');
    const [selectedYear, setSelectedYear] = useState(localStorage.getItem('year') || currentYear.toString());
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    const years = [];

    // Include next year if current month is December (month index 11)
    const maxYear = currentMonth === 11 ? currentYear + 1 : currentYear;

    for (let year = 2021; year <= maxYear; year++) {
        years.push(year.toString());
    }

    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.target.value);
        localStorage.setItem('quarter', e.target.value);
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
        localStorage.setItem('year', e.target.value);

    };

    return (
        <div style={{ fontWeight: "500" ,display:"flex"}}>
            <label htmlFor="quarter-select">Quarter: </label>
            <select id="quarter-select"   className="filter-style1" style={{
                marginRight: "5px",
                size: "200px",
                padding: "0px",
              }} value={selectedQuarter} onChange={handleQuarterChange}>
                {quarters.map((quarter) => (
                    <option key={quarter} value={quarter}>
                        {quarter}
                    </option>
                ))}
            </select>
            {" "}
            <label htmlFor="year-select">Year: </label>
            <select id="year-select"   className="filter-style1" style={{
                marginRight: "5px",
                size: "200px",
                margin: "0px",
                padding: "0px",
              }} value={selectedYear} onChange={handleYearChange}>
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default PeriodSelector;
